import { NgClass } from '@angular/common';
import { ChangeDetectionStrategy, Component } from '@angular/core';

import { ParticipantImageService } from '@frontend/sports/participant-image/feature';
import { IconCustomComponent } from '@frontend/vanilla/shared/icons';

import { BetBuilderOptionComponent } from './bet-builder-option.component';
import { MarketHelpComponent } from './market-help/market-help.component';
import { OptionGroupRendererDirective } from './option-group-renderer.directive';
import { BaseOptionGroupStatisticsService } from './player-statistics/base-option-group-statistics.service';
import { OptionGroupPlayerStatisticsService } from './player-statistics/option-group-player-statistics.service';
import { RegularOptionGroupComponent } from './regular-option-group.component';

@Component({
    selector: 'ms-bet-builder-standard-option-group',
    templateUrl: './bet-builder-standard-option-group.component.html',
    providers: [ParticipantImageService, OptionGroupPlayerStatisticsService, BaseOptionGroupStatisticsService],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [NgClass, MarketHelpComponent, BetBuilderOptionComponent, OptionGroupRendererDirective, IconCustomComponent],
})
export class BetBuilderStandardOptionGroupComponent extends RegularOptionGroupComponent {}
